<template>
  <div class="error-page">
    <i class="el-icon-question"></i>
    <h1>Page not Found!</h1>
    <p class="text-center">
      <el-link :href="oldPath" v-text="oldPath"></el-link> <br />
      Please coordinate with your system administrator.
    </p>
  </div>
</template>
<script>
export default {
  name: "error_404",
  computed: {
    oldPath() {
      return `${window.location.origin}${this.$route.params.oldPath}`;
    }
  }
};
</script>
<style lang="css" scoped>
.error-page * {
  color: #f56c6c;
}
.error-page {
  background: #fff;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.error-page i {
  font-size: 64px;
  margin-bottom: 20px;
}
</style>
